import { __decorate, __metadata, __extends, __param } from 'tslib';
import { Directive, Input, HostBinding, ContentChild, ContentChildren, QueryList, Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, HostListener, Optional, Self, ElementRef, isDevMode, forwardRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, NgControl, FormsModule } from '@angular/forms';
import { UIKitIconsModule } from '@uikit/components/uk-icons';
import { UkBaseFormControl, UkChildItemComponent, UIKitCommonModule } from '@uikit/components/common';
import { UkUserAgentDetectorService, UkCoreModule } from '@uikit/components/uk-core';
import { UIKitTooltipModule } from '@uikit/components/uk-tooltip';
import { UkBoolean, IS_DELETE_KEY, IS_DIGIT_KEY, IS_ENTER_KEY, GET_NUMBER_CHAR, IS_SYSTEM_KEY, KEYS } from '@uikit/components/helpers';
import { format, isDate } from 'date-fns';

var UkSuffix = /** @class */ (function () {
    function UkSuffix() {
    }
    UkSuffix = __decorate([
        Directive({
            selector: '[ukSuffix]'
        })
    ], UkSuffix);
    return UkSuffix;
}());

var UkPrefix = /** @class */ (function () {
    function UkPrefix() {
    }
    UkPrefix = __decorate([
        Directive({
            selector: '[ukPrefix]',
        })
    ], UkPrefix);
    return UkPrefix;
}());

var uniqueId = 0;
var UkHint = /** @class */ (function () {
    function UkHint() {
        this.id = "uk-hint-" + uniqueId++;
        this.isAlignedRight = this.align === 'right';
    }
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkHint.prototype, "align", void 0);
    __decorate([
        HostBinding('attr.id'),
        Input(),
        __metadata("design:type", Object)
    ], UkHint.prototype, "id", void 0);
    __decorate([
        HostBinding('class.right'),
        __metadata("design:type", Object)
    ], UkHint.prototype, "isAlignedRight", void 0);
    UkHint = __decorate([
        Directive({
            selector: 'uk-hint',
            host: {
                class: 'uk-hint',
            },
        })
    ], UkHint);
    return UkHint;
}());

var uniqueId$1 = 0;
var UkError = /** @class */ (function () {
    function UkError() {
        this.id = "uk-error-" + uniqueId$1++;
    }
    __decorate([
        HostBinding('attr.id'),
        Input(),
        __metadata("design:type", String)
    ], UkError.prototype, "id", void 0);
    UkError = __decorate([
        Directive({
            selector: 'uk-error',
            host: {
                class: 'uk-error',
            },
        })
    ], UkError);
    return UkError;
}());

var uniqueId$2 = 0;
var UkLabel = /** @class */ (function () {
    function UkLabel() {
        this.id = "uk-label-" + uniqueId$2++;
        this.isAlignedRight = this.align === 'right';
    }
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkLabel.prototype, "align", void 0);
    __decorate([
        HostBinding('attr.id'),
        Input(),
        __metadata("design:type", Object)
    ], UkLabel.prototype, "id", void 0);
    __decorate([
        HostBinding('class.right'),
        __metadata("design:type", Object)
    ], UkLabel.prototype, "isAlignedRight", void 0);
    UkLabel = __decorate([
        Directive({
            selector: 'uk-label',
        })
    ], UkLabel);
    return UkLabel;
}());

var NO_CONTROL_FOUND = "No control of type UkBaseFormControl was found inside the uk-form-field.";
var UkFormField = /** @class */ (function () {
    function UkFormField(cdRef) {
        this.cdRef = cdRef;
        this.isPassword = false;
        this.isValueShown = false;
        this.optionalText = 'Optional';
    }
    UkFormField.prototype.toggleShow = function () {
        this.isValueShown = !this.isValueShown;
        this.control.type = this.isValueShown ? 'text' : 'password';
    };
    /** ===> Error Handling <=== */
    UkFormField.prototype.getDefaultErrors = function () {
        var _this = this;
        if (this.control.errors) {
            this.controlErrors = Object.keys(this.control.errors).map(function (key) { return _this.control.errors[key]; });
        }
    };
    Object.defineProperty(UkFormField.prototype, "shouldDisplayError", {
        get: function () {
            this.getDefaultErrors();
            return (((this.errorChildren && this.errorChildren.length > 0) ||
                (this.controlErrors && this.controlErrors.length > 0)) &&
                (this.control.invalid && this.control.touched));
        },
        enumerable: true,
        configurable: true
    });
    /** ===> Angular LifeCycle Hooks <=== */
    UkFormField.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.validateControl();
        if (this.control.controlType === 'input' || this.control.controlType === 'input-ssn') {
            var inputControl = this.control;
            this.isPassword = inputControl.type === 'password';
        }
        // To Update UI
        this.control.statusChange.subscribe(function () {
            _this.cdRef.markForCheck();
        });
        this.control.focusedChange.subscribe(function () { _this.cdRef.markForCheck(); });
        this.control.valueChange.subscribe(function () { _this.cdRef.markForCheck(); });
    };
    /** Throws an error if no control (UkFormFieldControl) is found/contained */
    UkFormField.prototype.validateControl = function () {
        if (!this.control) {
            throw Error(NO_CONTROL_FOUND);
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkFormField.prototype, "hint", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkFormField.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkFormField.prototype, "tooltip", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkFormField.prototype, "fieldName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UkFormField.prototype, "hideLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkFormField.prototype, "optionalText", void 0);
    __decorate([
        ContentChild(UkBaseFormControl, { static: true }),
        __metadata("design:type", Object)
    ], UkFormField.prototype, "control", void 0);
    __decorate([
        ContentChildren(UkError),
        __metadata("design:type", QueryList)
    ], UkFormField.prototype, "errorChildren", void 0);
    __decorate([
        ContentChildren(UkHint),
        __metadata("design:type", QueryList)
    ], UkFormField.prototype, "hintChildren", void 0);
    __decorate([
        ContentChildren(UkLabel),
        __metadata("design:type", QueryList)
    ], UkFormField.prototype, "labelChildren", void 0);
    __decorate([
        ContentChildren(UkPrefix),
        __metadata("design:type", QueryList)
    ], UkFormField.prototype, "prefixChildren", void 0);
    __decorate([
        ContentChildren(UkSuffix),
        __metadata("design:type", QueryList)
    ], UkFormField.prototype, "suffixChildren", void 0);
    UkFormField = __decorate([
        Component({
            selector: 'uk-form-field',
            exportAs: 'ukFormfield',
            template: "\r\n<!-- LABELS -->\r\n<div class=\"uk-form-field__label\">\r\n  <label class=\"uk-label\" [class.sr-only]=\"hideLabel\"\r\n    *ngIf=\"label\"\r\n    [for]=\"control.id\">{{label}}\r\n    <span aria-hidden=\"true\"\r\n      *ngIf=\"!control.required\"></span>\r\n    <span *ngIf=\"tooltip\" ukIcon=\"question\" \r\n      ukTooltipBackground=\"white\" [ukTooltip]=\"tooltip\" ukTooltipPosition=\"top\">\r\n    </span>\r\n  </label>\r\n  <ng-content select=\".uk-label:not([align='right'])\"></ng-content>\r\n  <ng-content select=\".uk-label[align='right']\"></ng-content>\r\n  <button class=\"uk-label uk-password\"\r\n    type=\"button\"\r\n    aria-hidden=\"true\"\r\n    tabindex=\"-1\"\r\n    align=\"right\"\r\n    ukIcon=\"eye-outline\"\r\n    ukIconColor=\"text\"\r\n    *ngIf=\"isPassword\"\r\n    (click)=\"toggleShow()\">\r\n    {{ isValueShown ? 'Hide' : 'Show' }}\r\n  </button>\r\n</div>\r\n\r\n<!-- MAIN INPUT -->\r\n<div class=\"uk-form-field__main\" [class.invalid]=\"control.invalid && control.touched\"\r\n  (click)=\"control.onClick && control.onClick($event)\">\r\n\r\n  <!-- PREFIX -->\r\n  <div class=\"uk-form-field__main-prefix\"\r\n    *ngIf=\"prefixChildren.length\">\r\n    <ng-content select=\"[ukPrefix]\"></ng-content>\r\n  </div>\r\n\r\n  <!-- INPUT -->\r\n  <div class=\"uk-form-field__main-input\"\r\n    #inputRef>\r\n    <ng-content></ng-content>\r\n  </div>\r\n\r\n  <!-- SUFFIX -->\r\n  <div class=\"uk-form-field__main-suffix\"\r\n    *ngIf=\"suffixChildren.length\">\r\n    <ng-content select=\"[ukSuffix]\"></ng-content>\r\n  </div>\r\n</div>\r\n\r\n<!-- HINT & ERROR -->\r\n<div class=\"uk-form-field__messages\">\r\n  <!-- ERROR -->\r\n  <div class=\"uk-form-field__messages-error\"\r\n    *ngIf=\"shouldDisplayError\">\r\n    <ng-content select=\"uk-error\"></ng-content>\r\n    <!-- DEFAULT ERRORS -->\r\n    <uk-error *ngFor=\"let err of controlErrors\">\r\n      {{ err.message( fieldName ? fieldName : label, control.ngControl.getError(err.name)) }}\r\n    </uk-error>\r\n  </div>\r\n  <!-- HINT -->\r\n  <div class=\"uk-form-field__messages-hint\"\r\n    *ngIf=\"!shouldDisplayError\">\r\n    <uk-hint *ngIf=\"hint\">{{hint}}</uk-hint>\r\n    <ng-content select=\"uk-hint:not([align='right'])\"></ng-content>\r\n    <ng-content select=\"uk-hint[align='right']\"></ng-content>\r\n  </div>\r\n</div>\r\n",
            changeDetection: ChangeDetectionStrategy.OnPush,
            encapsulation: ViewEncapsulation.None,
            host: {
                class: 'uk-form-field',
                '[class.uk-form-field-disabled]': 'control?.disabled',
                '[class.uk-form-field-focus]': 'control?.focused',
                '[class.uk-form-field-invalid]': 'control?.invalid && control?.touched',
            }
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef])
    ], UkFormField);
    return UkFormField;
}());

var UkPasswordStrength = /** @class */ (function () {
    function UkPasswordStrength(cdr) {
        this.cdr = cdr;
        this.visible = false;
        this.strengthValue = 0;
        this.validationValue = 20;
        this.validations = [
            { valid: false, description: 'One uppercase letter', validation: function (value) { return value ? /[A-Z]/g.test(value) : false; } },
            { valid: false, description: 'One number', validation: function (value) { return value ? /\d/g.test(value) : false; } },
            { valid: false, description: 'One lowercase letter', validation: function (value) { return value ? /[a-z]/g.test(value) : false; } },
            { valid: false, description: '8 - 50 characters', validation: function (value) { return value ? value.length >= 8 && value.length <= 50 : false; } },
            { valid: false, description: 'One Symbol (#?!@$%^&*+-)', validation: function (value) { return value ? new RegExp('(?=.*[#?!@$%^&*+-])', 'g').test(value) : false; } },
        ];
        this.strengthLevels = [
            { name: 'Weak', color: 'error', valid: function (value) { return value < 60; } },
            { name: 'Fair', color: 'warning', valid: function (value) { return value >= 60 && value < 80; } },
            { name: 'Good', color: 'info', valid: function (value) { return value >= 80 && value < 100; } },
            { name: 'Strong', color: 'success', valid: function (value) { return value === 100; } }
        ];
        // Set a default value to avoid undefined errors
        this.currentStrengthLevel = this.strengthLevels[0];
    }
    Object.defineProperty(UkPasswordStrength.prototype, "field", {
        set: function (value) {
            var _this = this;
            this._field = value;
            this._field.valueChanges.subscribe(function (v) {
                if (!_this.evaluate(v) && v !== '') {
                    _this._field.setErrors({ ukPasswordStrength: _this.strengthValue });
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    UkPasswordStrength.prototype.evaluate = function (password) {
        var _this = this;
        var controlValid = true;
        var newStrengthValue = 0;
        this.validations.forEach(function (validation, idx) {
            validation.valid = validation.validation(password);
            newStrengthValue += validation.valid ? _this.validationValue : 0;
            controlValid = controlValid && validation.valid;
        });
        this.strengthValue = newStrengthValue;
        var a = 0;
        var isFound = false;
        var len = this.strengthLevels.length;
        while (a < len && !isFound) {
            if (this.strengthLevels[a].valid(this.strengthValue)) {
                this.currentStrengthLevel = this.strengthLevels[a];
                isFound = true;
            }
            a++;
        }
        this.cdr.markForCheck();
        return controlValid;
    };
    UkPasswordStrength.prototype.show = function () {
        this.visible = true;
        this.cdr.markForCheck();
    };
    UkPasswordStrength.prototype.hide = function () {
        this.visible = false;
        this.cdr.markForCheck();
    };
    __decorate([
        Input(),
        __metadata("design:type", AbstractControl),
        __metadata("design:paramtypes", [AbstractControl])
    ], UkPasswordStrength.prototype, "field", null);
    UkPasswordStrength = __decorate([
        Component({
            selector: 'uk-password-strength',
            template: "<ng-container *ngIf=\"visible\">\r\n    <div class=\"password-strength__bar\">\r\n        <div class=\"password-strength__bar__progress uk-background-{{currentStrengthLevel.color}}\" [style.width.%]=\"strengthValue\">\r\n            {{ currentStrengthLevel.name }}\r\n        </div>\r\n    </div>\r\n    <div class=\"password-strength__validations\" *ngFor=\"let validation of validations\">\r\n        <i *ngIf=\"!validation.valid\" style=\"font-size: 6px;\" ukIcon=\"cancel\" class=\"uk-text-error\" ></i>\r\n        <i *ngIf=\"validation.valid\" style=\"font-size: 6px;\" ukIcon=\"success\" class=\"uk-text-success\"></i>\r\n        <span>{{ validation.description }}</span>\r\n    </div>\r\n</ng-container>\r\n",
            host: { class: 'password-strength' },
            changeDetection: ChangeDetectionStrategy.OnPush,
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef])
    ], UkPasswordStrength);
    return UkPasswordStrength;
}());

var INVALID_INPUT = 'input type is not supported';
var VALID_INPUTS = [
    'text',
    'number',
    'password',
    'color',
    'date',
    'month',
    'week',
    'time',
    'email',
    'search',
    'tel',
    'url'
];
var UkBaseInput = /** @class */ (function (_super) {
    __extends(UkBaseInput, _super);
    function UkBaseInput(elementRef, ngControl, componentName) {
        if (componentName === void 0) { componentName = 'input'; }
        var _this = _super.call(this, ngControl, componentName) || this;
        _this.elementRef = elementRef;
        _this.ngControl = ngControl;
        _this.inputValue = _this.elementRef.nativeElement;
        return _this;
    }
    UkBaseInput.prototype.onInputChange = function ($event) {
        var input = $event.target;
        this.value = input.value;
        this.setValue(input.value);
    };
    /** ===> Manage Focus <=== */
    UkBaseInput.prototype.onInputFocus = function () { this.focused = true; };
    UkBaseInput.prototype.onInputBlur = function () { this.focused = false; };
    Object.defineProperty(UkBaseInput.prototype, "type", {
        // type property
        get: function () { return this._type; },
        set: function (value) {
            this._type = value || 'text';
            this.validateType();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkBaseInput.prototype, "inputDisabled", {
        get: function () { return this.disabled ? '' : null; },
        enumerable: true,
        configurable: true
    });
    UkBaseInput.prototype.onClick = function () { this.elementRef.nativeElement.focus(); };
    UkBaseInput.prototype.setValue = function (value) {
        if (this.inputValue.value !== value) {
            this.inputValue.value = value;
        }
        _super.prototype.setValue.call(this, value);
    };
    UkBaseInput.prototype.validateType = function () {
        var isInvalidInput = VALID_INPUTS.indexOf(this._type) < 0;
        if (isInvalidInput) {
            throw Error(this._type + " " + INVALID_INPUT);
        }
    };
    __decorate([
        HostListener('input', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UkBaseInput.prototype, "onInputChange", null);
    __decorate([
        HostListener('focus'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkBaseInput.prototype, "onInputFocus", null);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkBaseInput.prototype, "onInputBlur", null);
    __decorate([
        HostBinding('readonly'), Input(), UkBoolean(),
        __metadata("design:type", Object)
    ], UkBaseInput.prototype, "readonly", void 0);
    __decorate([
        HostBinding('attr.aria-describedby'),
        __metadata("design:type", String)
    ], UkBaseInput.prototype, "ariaDescribedby", void 0);
    __decorate([
        HostBinding('attr.placeholder'), Input(),
        __metadata("design:type", String)
    ], UkBaseInput.prototype, "placeholder", void 0);
    __decorate([
        HostBinding('attr.type'),
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkBaseInput.prototype, "type", null);
    __decorate([
        HostBinding('attr.disabled'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UkBaseInput.prototype, "inputDisabled", null);
    UkBaseInput = __decorate([
        __param(1, Optional()), __param(1, Self()),
        __metadata("design:paramtypes", [ElementRef,
            NgControl, String])
    ], UkBaseInput);
    return UkBaseInput;
}(UkBaseFormControl));

var UkMask = /** @class */ (function (_super) {
    __extends(UkMask, _super);
    function UkMask(elementRef, ngControl, componentName, userAgentDetectorService) {
        var _this = _super.call(this, elementRef, ngControl, componentName) || this;
        _this.ngControl = ngControl;
        _this.userAgentDetectorService = userAgentDetectorService;
        _this._secondSeparator = '';
        _this.secondSeparatorReg = new RegExp('');
        _this.leftToRight = true;
        /**
         * Function to transform the value if this is assigned on initialize
         */
        _this.functionAfterContentInit = new Function();
        _this._showMaskTyped = false;
        return _this;
    }
    Object.defineProperty(UkMask.prototype, "showMaskTyped", {
        get: function () { return this._showMaskTyped; },
        set: function (value) {
            if (value) {
                this._showMaskTyped = value;
            }
            this.separator = this._separator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkMask.prototype, "separator", {
        get: function () { return this._separator; },
        set: function (value) {
            this._separator = value;
            this.separatorReg = new RegExp(this.showMaskTyped ?
                "[\\" + this._separator + "\\_]" :
                "\\" + this._separator, 'g');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkMask.prototype, "secondSeparator", {
        get: function () { return this._secondSeparator; },
        set: function (value) {
            this._secondSeparator = value;
            this.secondSeparatorReg = new RegExp(this.showMaskTyped ?
                "[\\" + this._secondSeparator + "\\_]" :
                "\\" + this._secondSeparator, 'g');
        },
        enumerable: true,
        configurable: true
    });
    UkMask.prototype.onKeyUp = function ($event) {
        var input = $event.target;
        var value = input.value;
        if (IS_DELETE_KEY($event.key)) {
            this.keyUpHandler(input, value);
        }
    };
    UkMask.prototype.oninput = function ($event /*: InputEvent is commented because fails in IE11 */) {
        if (this.userAgentDetectorService.getUserAgent() === 'ANDROID') {
            var input = $event.target;
            if ($event.isComposing && $event.data) {
                var pos = $event.data.length - 1;
                var key = String($event.data.charCodeAt(pos));
                if (IS_DIGIT_KEY($event.data[pos])) {
                    this.keyDownHandler(input, key);
                }
            }
            else {
                this.keyUpHandler(input, input.value);
            }
        }
    };
    UkMask.prototype.onKeyDown = function ($event) {
        var input = $event.target;
        var key = $event.key;
        if (!this.isSystemKey($event)) {
            $event.preventDefault();
        }
        if (this.isValidKey($event)) {
            this.keyDownHandler(input, key);
        }
    };
    // Angular LifeCycle Hooks
    UkMask.prototype.ngAfterContentInit = function () { if (this.value) {
        this.functionAfterContentInit();
    } };
    UkMask.prototype.registerAfterContentInit = function (fn) { this.functionAfterContentInit = fn; };
    Object.defineProperty(UkMask.prototype, "maskSections", {
        get: function () { return this._maskSections; },
        set: function (value) {
            this._maskSections = value;
            this.setMaxLength();
            this.createRegExp();
        },
        enumerable: true,
        configurable: true
    });
    UkMask.prototype.keyUpHandler = function (input, value) {
        var cPos = input.selectionStart;
        var cTxt = this.cleanText(value, cPos, cPos);
        this.setFormatedText(cTxt.value, cTxt.position, input, true);
    };
    UkMask.prototype.keyDownHandler = function (input, key) {
        var value = input.value;
        var cPos = input.selectionStart;
        var cTxt = this.cleanText(value, cPos, input.selectionEnd);
        value = cTxt.value;
        cPos = cTxt.position;
        if (value.length < this.maxLength) {
            var before = value.substring(0, cPos);
            var after = value.substring(cPos);
            var newValue = this.proccessKeyDown(before, after, key);
            this.setFormatedText(newValue, cPos + 1, input, true);
        }
        if (IS_ENTER_KEY(key)) {
            if (input.form) {
                if (!this.invalid && input.form.checkValidity()) {
                    input.form.submit();
                }
            }
        }
    };
    UkMask.prototype.createRegExp = function () {
        var mask = [];
        this.maskSections.forEach(function (part) {
            var partExp = "(\\d{" + part + "})";
            mask.push(partExp);
        });
        this.mask = new RegExp("^" + mask.join('') + ".*");
    };
    UkMask.prototype.setPlaceHolder = function () {
        var pad = new Array(this.maxLength + 1).join('0');
        this.placeholder = this.format(pad).replace(new RegExp('0', 'g'), '#');
    };
    UkMask.prototype.setMaxLength = function () {
        var sepChars = this.separator.length * (this.maskSections.length - 1);
        this.maxLength = this.maskSections.indexOf(-1) >= 0 ? 50 :
            this.maskSections.reduce(function (p, c) { return p + c; }) + sepChars;
    };
    UkMask.prototype.setFormatedText = function (value, position, input, end) {
        if (end === void 0) { end = false; }
        var newValues = this.spaceFormat(value, position);
        var newPos = newValues.position;
        // Set value in control without mask
        this.value = newValues.value;
        // Set value in view with mask
        var newVal = this.showMask(newValues.value);
        input.value = newVal;
        input.selectionStart = newPos;
        if (end) {
            input.selectionEnd = newPos;
        }
    };
    UkMask.prototype.proccessKeyDown = function (before, after, key) {
        return before + GET_NUMBER_CHAR(key) + after;
    };
    UkMask.prototype.cleanText = function (value, cPos, cEnd) {
        var newValue = value;
        // Remove Selected text
        if (cPos !== cEnd) {
            newValue = value.substring(0, cPos) + value.substring(cEnd);
        }
        cPos = this.spaceCaretPosition(value, cPos);
        return {
            position: cPos,
            value: newValue.replace(this.separatorReg, '')
        };
    };
    // Add spaces
    UkMask.prototype.spaceFormat = function (value, position) {
        var secondValue = '';
        // Check if is dynamic mask(a negative value in this.maskSections)
        var dynamicMask = this.maskSections.indexOf(-1) >= 0 ? true : false;
        // Check if secondValue and secondSeparator exist
        if (dynamicMask && this.maskSections.length === 3 &&
            this.secondSeparator && value.indexOf(this.secondSeparator) >= 0) {
            secondValue = value.substr(value.indexOf(this.secondSeparator) + this.secondSeparator.length, this.maskSections[2]);
            value.replace(this.secondSeparatorReg, '');
            value = value.substring(0, value.indexOf(this.secondSeparator));
        }
        // Populate maskSections if is dynamic
        var sections;
        if (dynamicMask) {
            sections = new Array(Math.ceil(value.length / this.maskSections[0]));
            for (var i = 0; i < sections.length; i++) {
                sections[i] = this.maskSections[0];
            }
        }
        else {
            sections = this.maskSections.slice();
        }
        var newValue = [];
        var cIdx = this.leftToRight ? 0 : value.length;
        while (sections.length > 0) {
            var secMax = this.leftToRight ?
                cIdx + sections.shift() :
                cIdx - sections.shift();
            if (cIdx < value.length || dynamicMask) {
                if (position > secMax && secMax > 0) {
                    position++;
                }
                var start = this.leftToRight ? cIdx : secMax;
                var end = this.leftToRight ? secMax : cIdx;
                newValue.push(value.substring(start, end));
            }
            cIdx = secMax;
        }
        // Order values according to leftToRight property
        if (!this.leftToRight) {
            newValue = newValue.reverse();
        }
        var organizedValue = newValue.join(this.separator) +
            (this.secondSeparator && secondValue !== '' ? this.secondSeparator + secondValue : '');
        return {
            value: organizedValue,
            position: position
        };
    };
    // Put a guide of spaces to type according to maskSections
    UkMask.prototype.showMask = function (value) {
        if (this.showMaskTyped && this.type !== 'password') {
            var oldValues_1 = value.split(this.separator);
            var newVal_1 = [];
            this.maskSections.forEach(function (section, idx) {
                var tmpValue = oldValues_1[idx] ? oldValues_1[idx] : '';
                while (tmpValue.length < section) {
                    tmpValue += '_';
                }
                newVal_1.push(tmpValue);
            });
            return newVal_1.join(this.separator);
        }
        return value.toString();
    };
    // Get the right caret position without the spaces
    UkMask.prototype.spaceCaretPosition = function (value, cPos) {
        if (cPos > 0 && value.substring(cPos - 1, cPos) === this.separator) {
            cPos -= 1;
        }
        if (cPos > 0) {
            var matchs = value.substring(0, cPos).match(this.separatorReg);
            if (matchs) {
                cPos -= matchs.length;
            }
        }
        return cPos;
    };
    UkMask.prototype.checkErrors = function (forceUpdate) {
        (this.validationError && this.isFormatInvalid && this.value) ?
            this.setError(this.validationError.name, this.validationError) :
            this.removeError(this.validationError.name);
        _super.prototype.checkErrors.call(this);
    };
    Object.defineProperty(UkMask.prototype, "valueString", {
        get: function () { return this.value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkMask.prototype, "isFormatInvalid", {
        get: function () { return this.validator ? !this.validator.test(this.valueString) : false; },
        enumerable: true,
        configurable: true
    });
    UkMask.prototype.format = function (value) { return this.cleanText(value, 0, 0).value; };
    UkMask.prototype.isValidKey = function ($event) { return IS_DIGIT_KEY($event.key); };
    UkMask.prototype.isSystemKey = function ($event) { return IS_SYSTEM_KEY($event); };
    __decorate([
        Input(),
        __metadata("design:type", RegExp)
    ], UkMask.prototype, "validator", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkMask.prototype, "showMaskTyped", null);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkMask.prototype, "separator", null);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkMask.prototype, "secondSeparator", null);
    __decorate([
        HostListener('keyup', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], UkMask.prototype, "onKeyUp", null);
    __decorate([
        HostListener('input', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UkMask.prototype, "oninput", null);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], UkMask.prototype, "onKeyDown", null);
    return UkMask;
}(UkBaseInput));

var UkInvalidCurrencyError = {
    name: 'currency',
    message: function (label) { return label + " must be ###,###.##"; }
};
var UkCurrency = /** @class */ (function (_super) {
    __extends(UkCurrency, _super);
    function UkCurrency(ngControl, elementRef, cdr, userAgentDetectorService) {
        var _this = _super.call(this, elementRef, ngControl, 'input-currency', userAgentDetectorService) || this;
        _this.ngControl = ngControl;
        _this.cdr = cdr;
        _this.userAgentDetectorService = userAgentDetectorService;
        _this.value = '';
        _this.separator = ',';
        _this.secondSeparator = '.';
        // Negative value on mask section indicates a dynamic mask
        _this.maskSections = [3, -1, 2];
        _this.placeholder = '0.00';
        _this.validationError = UkInvalidCurrencyError;
        _this.validator = new RegExp('\\d');
        _this.leftToRight = false;
        return _this;
    }
    UkCurrency_1 = UkCurrency;
    UkCurrency.prototype.ngOnInit = function () {
        this.value = '';
    };
    UkCurrency.prototype.onBlur = function ($event) {
        // Add decimal values on Blur control
        var input = $event.target;
        var value = input.value;
        if (this.value === undefined) {
            _super.prototype.setValue.call(this, value);
        }
        if (this.secondSeparator && this.value && value.length > 0) {
            var sepIdx = value.indexOf(this.secondSeparator);
            var estimateDecimals = this.maskSections[this.maskSections.length - 1];
            var newValue = this.value;
            if (sepIdx < 0) {
                var noDec = '';
                for (var i = 0; i < estimateDecimals; i++) {
                    noDec += '0';
                }
                newValue += this.secondSeparator + noDec;
            }
            else {
                if (value.length < (sepIdx + estimateDecimals + 1)) {
                    var count = (sepIdx + estimateDecimals + 1) - value.length;
                    newValue = '0';
                    while (count) {
                        newValue += newValue;
                        count--;
                    }
                }
            }
            this.value = newValue;
            // this.setValue(newValue);
            this.setNgValue(newValue);
            _super.prototype.setValue.call(this, newValue);
            this.cdr.markForCheck();
        }
    };
    UkCurrency.prototype.setValue = function (value) {
        var _this = this;
        var newValue = value || '';
        // Avoid first number be null or zero
        while (newValue.substring(0, 1) === '0' &&
            newValue.substring(1, 2) !== this.secondSeparator) {
            newValue = newValue.substring(1);
            if (newValue.substring(0, 1) === this.separator) {
                newValue = newValue.substring(1);
            }
        }
        // Validate to have just one decimal character
        var decSep = 0;
        newValue.split('').forEach(function (c) { return c === _this.secondSeparator ? decSep++ : decSep; });
        if (decSep > 1) {
            var idxSep = newValue.indexOf(this.secondSeparator);
            newValue = newValue.substring(0, idxSep)
                + newValue.substring(idxSep + 1);
        }
        // Update control with value validated
        setTimeout(function () {
            _this.setNgValue(newValue);
            _super.prototype.setValue.call(_this, newValue);
            _this.cdr.markForCheck();
        }, 0);
    };
    UkCurrency.prototype.isValidKey = function ($event) {
        return (IS_DIGIT_KEY($event.key) ||
            this.isDecimalKey($event.key) ||
            $event.key === KEYS.Comma);
    };
    UkCurrency.prototype.isDecimalKey = function (key) {
        return key === KEYS.DecimalPoint || key === KEYS.Period || key === KEYS.MSDecimalPoint;
    };
    UkCurrency.prototype.isSystemKey = function ($event) {
        return (IS_SYSTEM_KEY($event) || this.isDecimalKey($event.key));
    };
    var UkCurrency_1;
    __decorate([
        HostListener('focusout', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UkCurrency.prototype, "onBlur", null);
    UkCurrency = UkCurrency_1 = __decorate([
        Directive({
            selector: "input[ukCurrency]",
            host: { 'class': 'uk-input text-right' },
            providers: [{ provide: UkBaseFormControl, useExisting: UkCurrency_1 }]
        }),
        __param(0, Optional()), __param(0, Self()),
        __metadata("design:paramtypes", [NgControl,
            ElementRef,
            ChangeDetectorRef,
            UkUserAgentDetectorService])
    ], UkCurrency);
    return UkCurrency;
}(UkMask));

function MASK_SECTION_VALIDATOR(maskSections, separator, optionalSeparator) {
    if (optionalSeparator === void 0) { optionalSeparator = false; }
    var _validator = [];
    maskSections.forEach(function (part, idx) {
        var _partExp = "(\\d{" + part + "})";
        _validator.push(_partExp);
        if (idx < maskSections.length - 1) {
            _validator.push("(\\" + separator + ")" + (optionalSeparator ? '?' : ''));
        }
    });
    return new RegExp("^" + _validator.join('') + "$");
}

var UK_SSN_SEPARATOR = '-';
var UK_SSN_MASK_SECTIONS = [3, 2, 4];
var UK_SSN_VALIDATOR = MASK_SECTION_VALIDATOR(UK_SSN_MASK_SECTIONS, UK_SSN_SEPARATOR, true);

var UkInvalidSSNError = {
    name: 'ssn',
    message: function () { return "The Social Security Number must be ###-##-####."; }
};
var UkSSN = /** @class */ (function (_super) {
    __extends(UkSSN, _super);
    function UkSSN(ngControl, elementRef, userAgentDetectorService) {
        var _this = _super.call(this, elementRef, ngControl, 'input-ssn', userAgentDetectorService) || this;
        _this.userAgentDetectorService = userAgentDetectorService;
        _this.type = 'password';
        _this.separator = UK_SSN_SEPARATOR;
        _this.maskSections = UK_SSN_MASK_SECTIONS;
        _this.setPlaceHolder();
        // VALIDATOR
        _this.validationError = UkInvalidSSNError;
        _this.validator = UK_SSN_VALIDATOR;
        return _this;
    }
    UkSSN_1 = UkSSN;
    UkSSN.prototype.format = function (value) {
        return _super.prototype.format.call(this, value).replace(this.mask, "$1" + this.separator + "$2" + this.separator + "$3");
    };
    var UkSSN_1;
    UkSSN = UkSSN_1 = __decorate([
        Directive({
            selector: "input[ukSSN]",
            host: { 'class': 'uk-input' },
            providers: [
                { provide: UkBaseFormControl, useExisting: UkSSN_1 }
            ],
        }),
        __param(0, Optional()), __param(0, Self()),
        __metadata("design:paramtypes", [NgControl,
            ElementRef,
            UkUserAgentDetectorService])
    ], UkSSN);
    return UkSSN;
}(UkMask));

var UK_DATE_SEPERATOR = '/';
var UK_DATE_MASK_SECTIONS = [2, 2, 4];
var UK_DATE_VALIDATOR = new RegExp('(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20|21)\\d\\d');

var UkInvalidDateError = {
    name: 'date',
    message: function (label) { return label + " must be MM/DD/YYYY."; }
};
var UkDate = /** @class */ (function (_super) {
    __extends(UkDate, _super);
    function UkDate(ngControl, elementRef, cdr, userAgentDetectorService) {
        var _this = _super.call(this, elementRef, ngControl, 'input-date', userAgentDetectorService) || this;
        _this.cdr = cdr;
        _this.userAgentDetectorService = userAgentDetectorService;
        // Bind a function to transform value if it's assigned on init input
        _super.prototype.registerAfterContentInit.call(_this, function () {
            _this.value = (_this.format(format(_this.value, 'MM/DD/YYYY')));
        });
        _this.separator = UK_DATE_SEPERATOR;
        _this.maskSections = UK_DATE_MASK_SECTIONS;
        _this.placeholder = 'MM / DD / YYYY';
        // VALIDATOR
        _this.validationError = UkInvalidDateError;
        _this.validator = UK_DATE_VALIDATOR;
        return _this;
    }
    UkDate_1 = UkDate;
    UkDate.prototype.format = function (value) {
        return _super.prototype.format.call(this, value).replace(this.mask, "$1" + this.separator + "$2" + this.separator + "$3");
    };
    UkDate.prototype.setValue = function (value) {
        var _this = this;
        // If value is not null or empty
        if (value && value.length >= this.maxLength) {
            if (isDate(value)) {
                value = this.value;
                // Hack to Update ng Value
                setTimeout(function () {
                    _this.setNgValue(value);
                    _this.cdr.markForCheck();
                }, 0);
            }
        }
        _super.prototype.setValue.call(this, value);
    };
    var UkDate_1;
    UkDate = UkDate_1 = __decorate([
        Directive({
            selector: "input[ukDate]",
            host: { 'class': 'uk-input' },
            providers: [{ provide: UkBaseFormControl, useExisting: UkDate_1 }],
        }),
        __param(0, Optional()), __param(0, Self()),
        __metadata("design:paramtypes", [NgControl,
            ElementRef,
            ChangeDetectorRef,
            UkUserAgentDetectorService])
    ], UkDate);
    return UkDate;
}(UkMask));

var UkPasswordStrengthDirective = /** @class */ (function () {
    function UkPasswordStrengthDirective() {
    }
    UkPasswordStrengthDirective.prototype.onFocus = function () { this.ukPasswordStrength.show(); };
    UkPasswordStrengthDirective.prototype.onBlur = function () { this.ukPasswordStrength.hide(); };
    __decorate([
        Input(),
        __metadata("design:type", UkPasswordStrength)
    ], UkPasswordStrengthDirective.prototype, "ukPasswordStrength", void 0);
    __decorate([
        HostListener('focus'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkPasswordStrengthDirective.prototype, "onFocus", null);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkPasswordStrengthDirective.prototype, "onBlur", null);
    UkPasswordStrengthDirective = __decorate([
        Directive({
            selector: 'input[ukPasswordStrength]'
        })
    ], UkPasswordStrengthDirective);
    return UkPasswordStrengthDirective;
}());

var UkInput = /** @class */ (function (_super) {
    __extends(UkInput, _super);
    function UkInput(ngControl, elementRef) {
        return _super.call(this, elementRef, ngControl, 'input') || this;
    }
    UkInput_1 = UkInput;
    var UkInput_1;
    UkInput = UkInput_1 = __decorate([
        Directive({
            selector: "input[ukInput], textarea[ukInput]",
            host: { class: 'uk-input' },
            providers: [{ provide: UkBaseFormControl, useExisting: UkInput_1 }]
        }),
        __param(0, Optional()), __param(0, Self()),
        __metadata("design:paramtypes", [NgControl,
            ElementRef])
    ], UkInput);
    return UkInput;
}(UkBaseInput));

var UkOptionComponent = /** @class */ (function (_super) {
    __extends(UkOptionComponent, _super);
    function UkOptionComponent(element) {
        var _this = _super.call(this, 'option') || this;
        _this.element = element;
        _this.role = 'option';
        return _this;
    }
    UkOptionComponent_1 = UkOptionComponent;
    UkOptionComponent.prototype.optionClicked = function () {
        if (!this.disabled) {
            this.selected = true;
        }
    };
    /** Gets the host DOM element. */
    UkOptionComponent.prototype.getHostElement = function () { return this.element.nativeElement; };
    Object.defineProperty(UkOptionComponent.prototype, "viewValue", {
        get: function () { return (this.getHostElement().textContent || '').trim(); },
        enumerable: true,
        configurable: true
    });
    // Angular LifeCycle Hooks
    UkOptionComponent.prototype.ngOnInit = function () {
        if (!this.value && isDevMode()) {
            // Warn user but set the viewValue as value
            console.warn("Value attribute is required otherwise select option \"" + this.viewValue + "\" never will be active");
        }
    };
    var UkOptionComponent_1;
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkOptionComponent.prototype, "value", void 0);
    __decorate([
        HostBinding('class.uk-option'),
        HostBinding('attr.role'),
        __metadata("design:type", Object)
    ], UkOptionComponent.prototype, "role", void 0);
    __decorate([
        HostListener('click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkOptionComponent.prototype, "optionClicked", null);
    UkOptionComponent = UkOptionComponent_1 = __decorate([
        Component({
            selector: 'uk-option',
            template: "<div class=\"uk-option-text\">\r\n  <ng-content></ng-content>\r\n</div>\r\n",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush,
            providers: [{
                    provide: UkChildItemComponent,
                    useExisting: forwardRef(function () { return UkOptionComponent_1; })
                }]
        }),
        __metadata("design:paramtypes", [ElementRef])
    ], UkOptionComponent);
    return UkOptionComponent;
}(UkChildItemComponent));

var UkFormControlsModule = /** @class */ (function () {
    function UkFormControlsModule() {
    }
    UkFormControlsModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                UIKitIconsModule,
                UIKitCommonModule,
                UkCoreModule,
                UIKitTooltipModule
            ],
            declarations: [
                UkFormField,
                UkPasswordStrength,
                UkPasswordStrengthDirective,
                UkOptionComponent,
                // Directives
                UkInput,
                UkSuffix,
                UkPrefix,
                UkError,
                UkLabel,
                UkHint,
                // Masks
                UkCurrency,
                UkSSN,
                UkDate
            ],
            exports: [
                UkFormField,
                UkPasswordStrength,
                UkPasswordStrengthDirective,
                UkOptionComponent,
                // Directives
                UkInput,
                UkSuffix,
                UkPrefix,
                UkError,
                UkLabel,
                UkHint,
                // Masks
                UkCurrency,
                UkSSN,
                UkDate
            ],
            entryComponents: [
                UkPasswordStrength
            ]
        })
    ], UkFormControlsModule);
    return UkFormControlsModule;
}());

export { UK_DATE_MASK_SECTIONS, UK_DATE_SEPERATOR, UK_DATE_VALIDATOR, UK_SSN_MASK_SECTIONS, UK_SSN_SEPARATOR, UK_SSN_VALIDATOR, UkFormControlsModule, UkFormField, UkInput, UkOptionComponent, UkError as ɵa, UkHint as ɵb, UkLabel as ɵc, UkPrefix as ɵd, UkSuffix as ɵe, UkPasswordStrength as ɵf, UkPasswordStrengthDirective as ɵg, UkBaseInput as ɵh, UkCurrency as ɵi, UkMask as ɵj, UkSSN as ɵk, UkDate as ɵl, MASK_SECTION_VALIDATOR as ɵm };
//# sourceMappingURL=uikit-components-uk-form-controls.js.map
